import { FVInitParams, ManagementApi, OperationsApi, OperationStatus } from "neurotec-megamatcherid-management-client";
import { IManagementInfo, IOperationsStatus, ModalityType, Status, StatusMessages } from "../types/FaceVerification";
import { useEffect } from "react";
import { NavigationActions } from "../components/Navigation/store/actions";
import { setOptionsActive } from "../components/Navigation/store/reducer";
import { AppState } from "../store/state";
import { AppActions, ModalityStateStatus } from "../store/actions";
import { setOperationState, showMessage } from "../store/reducer";
import { EnqueueSnackbar } from "notistack";
import { APIsState } from "../store/APIs/state";

export const getManagementInfo = async (ManagementApi: ManagementApi) => {
    try {
        const res = await ManagementApi.getManagementInfo();
        if (res.status === 200) {
            let response = JSON.stringify(res.data);
            return (JSON.parse(response) as IManagementInfo);
        }
        return null;
    } catch (error) {
        return null
    }
}

export const getInitParamsByManagementConfig = (managementInfo: IManagementInfo, mmidInitParams: FVInitParams) => {
    let initParams: FVInitParams = {};
    if (managementInfo && managementInfo.allowSettingsOverride) {
        initParams = mmidInitParams;
        initParams.advancedParameters = initParams.advancedParameters?.filter(x => x.key && x.value);
    } else {
        initParams.livenessMode = managementInfo.livenessMode
        initParams.checkIcaoCompliance = managementInfo.checkIcaoCompliance
    }
    return initParams;
}

export const liveAdjudication = (operationApi: OperationsApi, uuid: string, handleSuccess: () => void) => {
    setInterval(() => {

    }, 1000)
}

export const getNextModality = (
    state: AppState,
    dispatch: React.Dispatch<AppActions>,
    activeModality: ModalityType | null,
    setActiveModality: (modality: ModalityType | null) => void,
    setCheckState: (status: IOperationsStatus) => void
) => {
    let index = -1
    const operationState = state.operationState.modalityState.map((s, i) => {
        if (s.state === ModalityStateStatus.ACTIVE) {
            index = i + 1;
            return {
                modality: s.modality,
                state: ModalityStateStatus.DONE
            }
        }
        if (i === index) {
            return {
                modality: s.modality,
                state: ModalityStateStatus.ACTIVE
            }
        }
        return s
    })
    dispatch(setOperationState({subjectId: state.operationState.subjectId, modalityState: operationState}))
    if (activeModality === ModalityType.FACE_MODALITY) {
        if (state.activeModalities.voiceModality) {
            setActiveModality(ModalityType.VOICE_MODALITY)
            setCheckState(IOperationsStatus.IDLE)
        } else {
            setActiveModality(ModalityType.OVERVIEW)
            setCheckState(IOperationsStatus.IDLE)
        }
    } 
    if (activeModality === ModalityType.VOICE_MODALITY) {
        setActiveModality(ModalityType.OVERVIEW)
        setCheckState(IOperationsStatus.IDLE)
    }
}

export const useOperationStateEffect = (
    state: AppState,
    apisState: APIsState,
    dispatch: React.Dispatch<AppActions>,
    checkState: IOperationsStatus,
    setCheckState: (status: IOperationsStatus) => void,
    activeModality: ModalityType | null,
    setActiveModality: (modality: ModalityType | null) => void,
    navigationDispatch: (value: NavigationActions) => void,
    liveAdjudication: boolean,
    enqueueSnackbar: EnqueueSnackbar,
    faceOperationUUID: string,
    cancelAdjudication: (() => void) | undefined
) => {
    return useEffect(() => {
        let interval: NodeJS.Timeout | undefined;

        if (checkState === IOperationsStatus.SUCCESS) {
            if (liveAdjudication && faceOperationUUID && faceOperationUUID.length !== 0) {
                interval = setInterval(() => {
                    apisState.OperationsApi.getOperationByUUID({uuid: faceOperationUUID}).then(res => {
                        if (res && res.data && res.data.status) {
                            if (res.data.status === OperationStatus.AdjudicationPending) {
                                dispatch(showMessage({ message: StatusMessages[Status.ADJUDICATION_PENDING], type: "info"}))
                            } else if (res.data.status === OperationStatus.Success) {
                                clearInterval(interval)
                                getNextModality(state, dispatch, activeModality, setActiveModality, setCheckState)
                            } else {
                                clearInterval(interval)
                                cancelAdjudication?.()
                                if (res.data.status === OperationStatus.AgeCheckFailed) {
                                    dispatch(showMessage({ message: StatusMessages[Status.AGE_CHECK_FAILED], type: "error"}))
                                } else if (res.data.status === OperationStatus.LivenessCheckFailed) {
                                    dispatch(showMessage({ message: StatusMessages[Status.LIVENESS_CHECK_FAILED], type: "error"}))
                                } else {
                                    dispatch(showMessage({ message: "Adjudication failed", type: "error"}))
                                }
                            }
                        }
                    }).catch( e => {
                        enqueueSnackbar(e.message, {variant: "error"})
                    })
                }, 1000)
            } else {
                getNextModality(state, dispatch, activeModality, setActiveModality, setCheckState)
            }
        }
        if (checkState === IOperationsStatus.ACTIVE) {
            navigationDispatch(setOptionsActive(false))
        } else {
            navigationDispatch(setOptionsActive(true))
        }

        return () => {
            if (interval) clearInterval(interval)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkState, navigationDispatch, apisState])
}


